// extracted by mini-css-extract-plugin
export default {"page":"theme_page__2KA0i","form":"theme_form__qm-VC","details":"theme_details__adz1B","preview":"theme_preview__tNfCg"};